import { render, staticRenderFns } from "./tripadvisor.vue?vue&type=template&id=18ed54c5&"
import script from "./tripadvisor.vue?vue&type=script&lang=js&"
export * from "./tripadvisor.vue?vue&type=script&lang=js&"
import style0 from "./tripadvisor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports